var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.numPages),function(item){return _c('canvas',{key:item,attrs:{"id":'pdf'+item}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }